import { useEffect, useMemo, useState } from 'react';
import { useAppScopeStore } from '@frontend/scope';

export type LabelProps = {
  [id: string]: string;
};

/**
 * sort function for locations based on the location name
 */
export const sortLocationFunction = (locationLabels: LabelProps, a: string, b: string) => {
  const locationNameA = locationLabels[a];
  const locationNameB = locationLabels[b];
  return locationNameA.localeCompare(locationNameB);
};

export const useLocationHook = (): {
  locationLabels: LabelProps;
  sortedLocationIds: string[];
  isDataBeta: boolean;
  isUnifyLocation: boolean;
} => {
  const { getScopeName, selectedLocationIds, accessibleLocationData } = useAppScopeStore();
  const [sortedLocationIds, setSortedLocationIds] = useState<string[]>([]);
  const selectedLocationData = accessibleLocationData[selectedLocationIds[0]];

  /**
   * Get the location labels for the selected locations
   */
  const locationLabels: LabelProps = useMemo(() => {
    return selectedLocationIds.reduce((acc, locationId) => {
      return {
        ...acc,
        [locationId]: getScopeName(locationId),
      };
    }, {});
  }, [selectedLocationIds]);

  useEffect(() => {
    const sortedLocIds = selectedLocationIds.slice().sort((a, b) => sortLocationFunction(locationLabels, a, b));
    setSortedLocationIds(sortedLocIds);
  }, [selectedLocationIds]);

  const isDataBeta =
    Boolean(
      selectedLocationData?.groupId &&
        accessibleLocationData[selectedLocationData?.groupId]?.phoneTenantId !== selectedLocationData.phoneTenantId
    ) ?? false;

  const isUnifyLocation = Boolean(
    selectedLocationData?.groupId &&
      accessibleLocationData[selectedLocationData?.groupId]?.phoneTenantId === selectedLocationData.phoneTenantId
  );

  return {
    locationLabels,
    sortedLocationIds,
    isDataBeta,
    isUnifyLocation,
  };
};
